<template>
    <!-- overlay dropfile -->
    <div class="text-center">
        <v-overlay :value="stateDropFile" :opacity="0.9">
            <v-col cols="12" align="end">
            <v-btn small dark icon @click="closeDialog(), dropFileAlert = false">
                <v-icon class="icon-color">fa-solid fa-circle-xmark</v-icon>
            </v-btn>
            </v-col>
            <v-col v-if="!dropFileAlert" cols="12" justify="center" align="center" class="drop-file">
                <img :src="`${publicPath}/assets/img/chat/dropfile.png`" style="width: 300px; border-radius: 12px; margin-top: 10px;"/>
                <p class="sub-fontsize" style="color: white; margin-top: 20px;">{{$t('ChatSide.dropFile')}}</p>
            </v-col>
            <v-col v-else cols="12" justify="center" align="center" class="drop-file-alert">
                <img :src="`${publicPath}/assets/img/chat/dropfile-alert.png`" style="width: 300px; border-radius: 12px; margin-top: 10px;"/>
                <p class="sub-fontsize" style="color: white; margin-top: 20px;">{{$t('ChatSide.dropFileAlert')}}</p>
            </v-col>
        </v-overlay>
    </div>
</template>
<script>
  export default {
    props: {
        stateDropFile: Boolean,
    },
    data () {
        return {
            dropFileAlert: false,
            publicPath: process.env.VUE_APP_BASE_PATH,
        }
    },
    methods: {
        closeDialog () {
            this.$emit('closeComponents', { name: 'dropFile', value: false })
        },
    },
    watch: {
    },
  }
</script>
<style scoped>
.drop-file {
  border-style: dotted !important;
  border-width: thick !important;
  width: 400px !important;
  height: 300px !important;
  justify-items: center !important;
  background-color: #2463af !important;
  border-radius: 17px !important;
}

.drop-file-alert {
  border-style: dotted !important;
  border-width: thick !important;
  width: 400px !important;
  height: 300px !important;
  justify-items: center !important;
  background-color: #b90d00 !important;
  border-radius: 17px !important;
}
</style>